<template>
	<div>
		<div v-show="hasData" class="text_center" style="width:520px;margin:0 auto;">
			<h4 class="font_lg font_bold">
				<i class="fa fa-graduation-cap" aria-hidden="true"></i>
				{{ $t("Activation.Welcome") }}
			</h4>
			<p>{{ !otherUser ? $t("Activation.WelcomeTip") : $t("Activation.tip.otherUser") }}</p>
		</div>
		<div v-show="!hasData" class="text-center font_bold" v-html="errData"></div>
		<div class="text-center" v-show="hasData||errData">
			<md-button class="md-primary" @click="logout">{{ $t("user.sendEmail.login") }}</md-button>
		</div>
	</div>
</template>

<script>
import {userApi} from "@/common/api/userApi";

export default {
	data() {
		return {
			otherUser: false,
			hasData: false,
			errData: ""
		};
	},
	beforeMount() {
		let { status, email, token, purpose } = this.$route.query;
		if (purpose === "") {
			purpose = null;
		}

		if (status && status.startsWith("ACTIVATION_SUCCESS")) {
			this.updateWithStatus(status);
		} else {
			userApi
				.CheckToken({ email, token, purpose })
				.then(res => {
					this.updateWithStatus(res.nextStatus);
				})
				.catch(err => {
					this.errData = err;
				});
		}
	},
	methods: {
		updateWithStatus(status) {
			let { email, token } = this.$route.query;

			if (status === "SET_PASSWORD") {
				this.$router.replace(
					"/reset-password?email=" + this.emailReEncoding(email) + "&token=" + token
				);
			} else {
				if (status === "ACTIVATION_SUCCESS_OTHER_USER") {
					this.otherUser = true;
				}
				this.hasData = true;
			}
		},
    emailReEncoding(email) {
      return email.replace("+", "%2B");
    }
	}
};
</script>
